import { Field } from "@reactables/react-forms";
import PlanBtn from "./PlanBtn";
import { plans } from "@basicare/common/src/Constants/planTypes";

const Plans = () => {
  return (
    <div className="row">
      {plans.map((plan) => (
        <Field
          key={plan.planType}
          name="generalInformation.planType"
          component={PlanBtn}
          value={plan.planType}
          cols="4"
          plan={plan}
        />
      ))}
    </div>
  );
};

export default Plans;
